/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { Box, Link } from "@chakra-ui/react";
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useLocation } from "@reach/router";
import "../../styles/global.css";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();

  return (
    <Box bgColor={"black"} margin="0 auto">
      <Header />
      <Box as="main">{children}</Box>\
      <Footer />
    </Box>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
